module.exports = __webpack_public_path__ + "static/image/logo-family/logo_bmart.png?06d6afac";